/* src/app/global/telas/dashboard-usuario/dashboard-usuario.component.scss */
:host {
  display: block;
  width: 100%;
}
div:first-child {
  max-width: 1400px;
  margin: 0 auto;
  padding: 8px 16px;
}
/*# sourceMappingURL=dashboard-usuario.component.css.map */
